import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class UserStandRoleModel extends ApiModel {
  static get path() {
    return '/backend/user_stand_roles/{?id}';
  }

  @computed
  get userIri(): string {
    return this.get('user');
  }

  @computed
  get standIri(): string {
    return this.get('stand');
  }

  @computed
  get standistRole(): string {
    return this.get('standistRole');
  }

  @computed
  get fullName(): string {
    return (this.firstName && this.lastName) ? `${this.firstName} ${this.lastName}` : '';
  }

  @computed
  get company(): string {
    return this.get('company', '');
  }

  @computed
  get lastName(): string {
    return this.get('lastName');
  }

  @computed
  get firstName(): string {
    return this.get('firstName');
  }

  @computed
  get phone(): string {
    return this.get('phone');
  }
}
